import { render, staticRenderFns } from "./MeTag.vue?vue&type=template&id=55a07953"
import script from "./MeTag.vue?vue&type=script&lang=js"
export * from "./MeTag.vue?vue&type=script&lang=js"
import style0 from "./MeTag.vue?vue&type=style&index=0&id=55a07953&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports